/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { Layer } from "@vienna/common";

import { Plate } from "src/classes/plate/Plate";
import { DimensionsWrapper } from "src/components/Plate/Data/Dimensions";
import { MousePosition } from "src/components/Plate/Data/MousePosition";

interface Props {
  plate: Plate;
}
export function Internals({ plate }: Props) {
  plate.sessionManager.observe((state) => state.isCurrentSession); // need to observe for state updates
  return (
    <StyledInternals>
      <DimensionsWrapper session={plate.sessionManager.currentSession} />
      <MousePosition mouseTracker={plate.mouseTracker} />
    </StyledInternals>
  );
}

const StyledInternals = styled.div`
  position: absolute;
  bottom: 10px;
  left: 25px;
  display: flex;
  flex-direction: column;
  z-index: ${Layer.WIN_LAYER};
`;
